/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {VerifyAccountOwnershipRequest} from '@cash-web/protos/squareup/cash/cashdotapp/api.pb'
import {VerifyAccountOwnershipResponse} from '@cash-web/protos/squareup/cash/cashdotapp/api.pb'


export const verifyAccountOwnership = (request: VerifyAccountOwnershipRequest, options?: CashRequestOptions) => post<VerifyAccountOwnershipRequest, VerifyAccountOwnershipResponse>("/2.0/cash/verify-account-ownership", request, {...options, rejectOnError: true })